import * as React from 'react';
import { Link } from 'react-router-dom';
import Paths from '../../../../models/enums/paths';
import * as styles from './client-admin.module.scss';
import { withRouter, RouteComponentProps } from 'react-router';

interface Props {
  clientId: number;
  userRole: string;
}

const ClientAdminMenu = ({ clientId, userRole, location }: Props & RouteComponentProps) => {
  /** Checks user role to hide the tab if user is a Client Admin
   * Only tabs shown for client admin is Dashboards, Tags and Navigation
   */
  const hideTab = () => {
    return userRole === 'Client Admin';
  };

  return (
    <div>
      <ul className={styles.menu}>
        <Link
          to={Paths.EditClient.replace(':clientId', clientId.toString())}
          className={location.pathname.match(/clients\/\d+\/edit$/) ? styles.current : undefined}
          hidden={hideTab()}
        >
          <li className={styles.menuItem}>Edit Client</li>
        </Link>
        <Link
          to={Paths.ClientUsers.replace(':clientId', clientId.toString())}
          className={location.pathname.endsWith('users') ? styles.current : undefined}
          hidden={hideTab()}
        >
          <li className={styles.menuItem}>Users</li>
        </Link>
        <Link
          to={Paths.ClientDashboards.replace(':clientId', clientId.toString())}
          className={
            location.pathname.endsWith('dashboards') ||
            location.pathname.endsWith('dashboards/create') ||
            location.pathname.match(/dashboards\/\d+\/edit$/)
              ? styles.current
              : undefined
          }
        >
          <li className={styles.menuItem}>Dashboards</li>
        </Link>
        <Link
          to={Paths.ClientTags.replace(':clientId', clientId.toString())}
          className={location.pathname.endsWith('tags') ? styles.current : undefined}
        >
          <li className={styles.menuItem}>Tags</li>
        </Link>
        <Link
          to={Paths.ClientNavigation.replace(':clientId', clientId.toString())}
          className={location.pathname.endsWith('navigation') ? styles.current : undefined}
        >
          <li className={styles.menuItem}>Navigation</li>
        </Link>
        <Link
          to={Paths.ClientHelpDocuments.replace(':clientId', clientId.toString())}
          className={location.pathname.match(/edit\/help/) ? styles.current : undefined}
          hidden={hideTab()}
        >
          <li className={styles.menuItem}>Help Documents</li>
        </Link>
        <Link
          to={Paths.ClientAnnouncements.replace(':clientId', clientId.toString())}
          className={location.pathname.endsWith('announcements') ? styles.current : undefined}
          hidden={hideTab()}
        >
          <li className={styles.menuItem}>Announcements</li>
        </Link>
        <Link
          to={Paths.SnowflakeConfiguration.replace(':clientId', clientId.toString())}
          className={location.pathname.endsWith('snowflake') ? styles.current : undefined}
          hidden={hideTab()}
        >
          <li className={styles.menuItem}>Snowflake</li>
        </Link>
      </ul>
    </div>
  );
};

export default withRouter(ClientAdminMenu);
